import request from '@/utils/request'
const ticketURL = process.env.VUE_APP_BASE_API

export const SYSAPI = {
  // 获取当前用户所拥有的菜单权限
  getSysApp: (params: any) =>
    request({
      url: ticketURL + 'system/getApp',
      method: 'get',
      params
    }),

  getDashPerms: () =>
    request({
      url: ticketURL + 'system/dashPerms',
      method: 'get'
    })
}
